/* eslint-disable jsx-a11y/anchor-is-valid */
import './UnauthenticatedFooter.scss';
import { Footer } from '@lmig/lmds-react-footer';
import { Disclaimer } from '@lmig/lmds-react-typography';
import { LogoLibertyMutualMedallion, LogoLibertyMutualVert } from '@lmig/lmds-react-logos';
import { IconCPRA } from '@lmig/lmds-react-icons';
import { Link } from '@lmig/lmds-react-link';

export default function UnauthenticatedPageFooter() {

  const window: IWindow = global.window;
  function CRPAClick() {
    if (window?.utag?.gdpr) {
      window.utag.gdpr.showDoNotSellPrompt();
    }
  }

  return (
    <Footer fullWidth={true} className='unauthenticated-footer'>
      <div className={"portal-footer-top-section-one-brand"}>
        <div className="portal-footer-flexbox portal-footer portal-footer-bottom-border">
          <div className="footer-content">
            <div className="portal-footer-icon">
              <LogoLibertyMutualMedallion key="lm-desktop-logo-footer" className="lm-tablet-logo-footer" color="blue" />
            </div>
            <div className="portal-footer-flexbox portal-footer portal-footer-flexbox-link-rows">
              <div className="portal-content-links lm-blue-footer">
                <Link
                  rel="noopener noreferrer"
                  href="https://www.libertymutualgroup.com/about-lm/corporate-information/fraud-protection-tips"
                  target="_blank"
                  title="Fraud protection"
                  variant="inline"
                >
                  Fraud protection
                </Link>
                &nbsp;|&nbsp;
                <Link
                  rel="noopener noreferrer"
                  href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy"
                  target="_blank"
                  title="Liberty Mutual Privacy Policy"
                  variant="inline"
                >
                  Privacy policy
                </Link>
                &nbsp;|&nbsp;
                <Link
                  rel="noopener noreferrer"
                  href="https://www.libertymutualgroup.com/about-lm/corporate-information/security-policy"
                  target="_blank"
                  title="Security policy"
                  variant="inline"
                >
                  Security policy
                </Link>
                &nbsp;|&nbsp;
                <Link
                  rel="noopener noreferrer"
                  href="https://www.libertymutualgroup.com/about-lm/corporate-information/terms-and-conditions"
                  target="_blank"
                  title="View this site's terms and conditions"
                  variant="inline"
                >
                  Terms and conditions
                </Link>
              </div>
              <div className="portal-content-links lm-blue-footer">
                <span className="icon-link">
                  <IconCPRA color="blue" size="24" />
                  <a
                    rel="noopener noreferrer"
                    href="https://privacyportal.onetrust.com/hosted-webform/consent/50577d86-8d39-4310-9583-33e6d3da8e17/9b108b70-4ef6-4d93-b7ec-60e41f03b292"
                    target="_blank"
                    title="View your California Privacy Choices"
                  >
                    Your California Privacy Choices
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    rel="noopener noreferrer"
                    onClick={() => CRPAClick()}
                    target="_blank"
                    title="Do Not Sell or Share My Personal Information (CA Residents Only)"
                  >
                    Do Not Sell or Share My Personal Information (CA Residents Only)
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"container portal-footer-bottom-section-one-brand"}>
        <Disclaimer>
          <p>© {new Date().getFullYear()} Liberty Mutual Insurance Company, 175 Berkeley Street, Boston, MA 02116</p>
        </Disclaimer>
      </div>
    </Footer>
  );
}
